export const ROUTES = {
  AUTH: {
    LOGIN: "/login",
    SIGNUP: "/signup",
    VERIFY_EMAIL: "/verify-email/:token",
    RESET_PASSWORD: "/reset-password",
    SHAREPOINT_SETUP: "/auth/sharepoint",
  },
  DASHBOARD: {
    HOME: "/dashboard",
    QMS: {
      LIST: "/dashboard/qms-structure",
      DETAILS: "/dashboard/qms-structure/:id",
    },
    EDIT: "/dashboard/qms-elements/:id/edit",
    CREATE: "/dashboard/qms-elements/create",
    QMS_ELEMENTS: {
      ELEMENTS: "/dashboard/qms-elements",
      INTERNAL_ORGANIZATION: "/dashboard/qms-elements/internal-organization",
      THIRD_PARTY_USERS: "/dashboard/qms-elements/third-party-users",
    },
    QMS_ELEMENTS_EDIT: "/dashboard/qms-elements/edit/:elementId",
    USER_MANAGEMENT: {
      BASE: "/dashboard/user-management",
      USERS: "/dashboard/user-management/users",
      USERS_ADD: "/dashboard/user-management/users/add",
      USERS_EDIT: "/dashboard/user-management/users/:id/edit",
      USERS_DETAILS: "/dashboard/user-management/users/details/:id",
      USER_GROUPS: "/dashboard/user-management/user-groups",
      USER_GROUPS_ADD: "/dashboard/user-management/user-groups/add",
      USER_GROUPS_EDIT: "/dashboard/user-management/user-groups/:id/edit",
      USER_GROUPS_DETAILS: "/dashboard/user-management/user-groups/:id/details",
      USER_DETAILS:
        "/dashboard/user-management/user-groups/:groupId/user-details/:userId",
    },
    OWNER_USER_MANAGEMENT: "/dashboard/account-management",
    OWNER_USER_CREATE: "/dashboard/account-management/create",
    OWNER_USER_EDIT: "/dashboard/account-management/:id/edit",
    OWNER_USER_VIEW: "/dashboard/account-management/view/:userId",
    SETTINGS: "/dashboard/settings",
    // New routes for Owner-specific pages
    FILES: "/dashboard/files",
    DOCUMENTS: {
      LIST: "/dashboard/documents",
      MY_DOCUMENTS: "/dashboard/documents/my-documents",
      CREATE: "/dashboard/documents/create",
      TRACK_REVIEWS: "/dashboard/documents/reviews",
    },
    RECORDS: "/dashboard/records",
    MASTER_FILES: "/dashboard/master-files",
    REGISTERS: "/dashboard/registers",
    HELPDESK: "/dashboard/helpdesk",
    // New route for Super Admin
    TENANT_MANAGEMENT: {
      LIST: "/dashboard/tenant-management",
      CREATE: "/dashboard/tenant-management/create",
      EDIT: "/dashboard/tenant-management/:id/edit",
      VIEW: "/dashboard/tenant-management/:id/view",
    },
    SUBSCRIPTION_BILLING: "/dashboard/subscription-billing-management",
    SUBSCRIPTION_BILLING_VIEW_INVOICES:
      "/dashboard/subscription-billing-management/view-invoices/:tenantId",
    SUBSCRIPTION_BILLING_INVOICE_DETAILS:
      "/dashboard/subscription-billing-management/invoice-details/:invoiceId/:tenantId",
    QUALITY_ISSUES: "/dashboard/quality-issues",
  },
} as const;

export type RouteKeys = keyof typeof ROUTES;
export type AuthRouteKeys = keyof typeof ROUTES.AUTH;
export type DashboardRouteKeys = keyof typeof ROUTES.DASHBOARD;
